import { useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import { SMLRouteNames } from '../../../../routing/sml/SMLRoutes';
import { useShowSMLPricingModal, useSMLUpgradePrompt, useTourActive } from '../../../../redux/slices/appInfo/hooks';
import { getWatermarkChoice, subscribeWatermarkChoice } from '../choice/watermarkChoiceStore';

/** Any open dialog of the page: a Bootstrap modal, the asset viewer, a confirm dialog. */
const OPEN_DIALOG_SELECTOR = '.modal.show, [role="dialog"][aria-modal="true"], [role="alertdialog"]';

/** True when a dialog is on screen now. The automatic modals read it at the moment they open. */
export function isAnyDialogOpen(): boolean {
  return typeof document !== 'undefined' && document.querySelector(OPEN_DIALOG_SELECTOR) !== null;
}

/**
 * True while no automatic upsell modal may open (trial upsell spec 2026-10-13 §4): the tour runs,
 * the page is the welcome page, or another window of the app is open (the upgrade prompt, the
 * plans window, the choice of a file). A modal that cannot open waits for the next page.
 */
export function useAutoModalBlocked(): boolean {
  const { pathname } = useLocation();
  const isTourActive = useTourActive();
  const prompt = useSMLUpgradePrompt();
  const isPricingOpen = useShowSMLPricingModal();
  const choice = useSyncExternalStore(subscribeWatermarkChoice, getWatermarkChoice, getWatermarkChoice);
  const isWelcomePage = pathname.split('/').includes(SMLRouteNames.welcome);
  return isTourActive || isWelcomePage || prompt !== null || isPricingOpen || choice !== null;
}
